import React, { useState } from 'react';
import Popover from '../../../UI/Popover/Popover';
import Car from "../../../../assets/Icon/Car"; 
import Attachment from "../../../../assets/Icon/Attachment"; 
import cl from './TitleFile.module.css' 
import { baseFileURL } from '../../../../Api'; 
 
const TitleFile = ({ cargoService, containerService, defaultCargo   }) => {

    const [file, setFile] = useState(null); 

    const onUpdateClick = (event) => { 
        const newForm = new FormData();
        newForm.append('cargo_id', defaultCargo.id);
        
        if (file) {
            newForm.append('title_file', file);
        }
 
        cargoService.uploadTitleFile(newForm)
            .then(response => {
                containerService.fetchList()
            })
            .catch(error => {
                console.error(error);
            });   
          
    };
 
    return ( 
            <Popover placement='left' fullWidth={true} content={<>
                    <div style={{ minWidth: '200px' }} >
                        <div className={cl.modalHead} >
                            <h3>
                                <span className={cl.iconHead  } > <Attachment /></span>
                                <div style={{ display: 'flex', flexDirection: 'column' }}> 
                                    <div style={{ lineHeight: 1, fontSize: 14, fontWeight: 600 }}> Title დოკუმენტი</div> 
                                </div> 
                            </h3>
                        </div>

                        <div>  
  
                            <div className={cl.groupInput}> 
                                <div className={cl.inputDiv + ' ' + cl.uploadDiv}>
                                    <input type="file" name="title_file" className={cl.input}  onChange={e => setFile(e.target.files[0])} />
                                </div>
                            </div>
        
                            { defaultCargo.title_file && defaultCargo.title_file.length > 0 &&
                                <a className={ cl.link2ed} href={baseFileURL + defaultCargo.title_file} target='_blank' rel="noopener noreferrer">
                                    <Attachment props={{ height: '200px' }} /> Title-ს გადმოწერა
                                </a> 
                            }

                            <div className={cl.flexend}>
                                <button type="submit"  onClick={(event) => {
                                        onUpdateClick();
                                        event.stopPropagation(); // Prevents the popover from toggling when the button inside it is clicked
                                        event.target.closest('div[style*="position: absolute"]').previousSibling.click(); // Simulates clicking the trigger to close
                                    }} className={cl.btnPrimary} >შენახვა
                                </button>
                            </div>  
                        </div>
                    </div> 
                </>}>
 
 
                {defaultCargo.title_file && defaultCargo.title_file.length > 0 ? (
                    <div style={{display: 'flex', width: '100%'}}>
                        <span className={cl.BtnCargo +' '+ cl.greenbtn}><Car/></span>
                    </div>
                ) : ( 
                    <span className={cl.BtnCargo}><Car/></span>
                )
                }  
            </Popover>  
    );
};

export default TitleFile;